import { AnyAction, combineReducers, Reducer } from "redux";
import { connectRouter } from "connected-react-router";
import { rootReducerInterface } from "./typings/interfaces";

import globalReducer from "./containers/App/reducer";
import { reducer as auth } from "./routes/Auth";
import { reducer as ad } from "./routes/Ad";
import { reducer as favorite } from "./routes/Favorite";
import { reducer as store } from "./routes/Store";
import { reducer as hidden } from "./routes/Hidden";
import { reducer as search } from "./routes/Search";
import { reducer as adForm } from "./routes/AdForm";
import { reducer as promotion } from "./routes/Promotion";
import { reducer as phone } from "./routes/Phone";
import { reducer as cart } from "./routes/Cart";
import { reducer as credit } from "./routes/Credit";
import { reducer as chat } from "./routes/Chat";
import { reducer as systemMessage } from "./routes/SystemMessage";
import { reducer as makeModelInfo } from "./routes/MakeModelInfo";
import { reducer as configuration } from "./routes/Configuration";
import { adminReducer as admin } from "./routes/Admin/admin.ducks";

import history from "./history";

const rootReducer: Reducer<rootReducerInterface, AnyAction> = combineReducers({
  global: globalReducer,
  router: connectRouter(history),
  auth,
  ad,
  favorite,
  store,
  hidden,
  promotion,
  phone,
  cart,
  credit,
  chat,
  systemMessage,
  search,
  adForm,
  makeModelInfo,
  configuration,
  admin
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducer.ts